
export const APP_VERSION = "3.9.5"; // Die aktuelle Version der App
export const SUPPORTED_GAME_VERSION = ": Luna VI (Version 6.5)";
export const WISH_COST = 160;
export const PLACEHOLDER_ICON =
  "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

export const META_DATA = {
  default: {
    en: {
      title: "Genshin Impact Pity Tracker",
      description:
        "Track wishes, manage your collection, and predict Capturing Radiance! 100% private, ad-free, and secure.",
    },
    de: {
      title: "Genshin Impact Pity Tracker",
      description:
        "Verfolge Gebete, verwalte deine Sammlung & sage 'Gefangener Glanz' voraus! 100% privat, werbefrei und sicher.",
    },
  },
  guide: {
    en: {
      title: "Pity System & Guides | Genshin Impact Pity Tracker",
      description:
        "Learn everything about the Pity System, 50/50, Capturing Radiance, and how to use the tracker effectively.",
    },
    de: {
      title: "Pity-System & Anleitungen | Genshin Impact Pity Tracker",
      description:
        "Erfahre alles über das Pity-System, 50/50, 'Gefangener Glanz' und wie du den Tracker effektiv nutzt.",
    },
  },
  "guide/capturing-radiance": {
    en: {
      title: "Capturing Radiance Explained | Genshin Pity Tracker",
      description:
        "Discover the hidden 'Bad Luck Protection' system in Genshin Impact and learn how to track your C-State.",
    },
    de: {
      title: "Gefangener Glanz erklärt | Genshin Pity Tracker",
      description:
        "Entdecke das versteckte 'Pechschutz'-System in Genshin Impact und lerne, wie du deinen C-Status verfolgst.",
    },
  },
  "minigame/wish-simulator": {
    en: {
      title: "Wish Simulator | Genshin Impact Pity Tracker",
      description:
        "Test your gacha luck with a realistic Wish Simulator! Uses your current pity and guarantee status for an accurate simulation without spending Primogems.",
    },
    de: {
      title: "Gebets-Simulator | Genshin Impact Pity Tracker",
      description:
        "Teste dein Gacha-Glück mit einem realistischen Gebets-Simulator! Nutzt deinen aktuellen Pity-Stand und Garantie-Status für eine genaue Simulation ohne Urgestein.",
    },
  },
  profile: {
    en: {
      title: "My Profile & Collection | Genshin Impact Pity Tracker",
      description:
        "Analyze your gacha luck with a personal Luck Score and manage all your pulled characters and weapons in one place.",
    },
    de: {
      title: "Mein Profil & Sammlung | Genshin Impact Pity Tracker",
      description:
        "Analysiere dein Gacha-Glück mit einem persönlichen Glückswert und verwalte alle deine gezogenen Figuren und Waffen.",
    },
  },
};

export const COMMUNITY_LINKS = [
  {
    category: "Official News & Updates",
    links: [
      {
        title: "Official Website",
        description: "Announcements, events, and character previews.",
        icon: "/assets/icons/hoyoverse.svg",
        url: "https://genshin.hoyoverse.com/",
      },
      {
        title: "HoYoLAB",
        description: "Official community forum, tools, and daily check-in.",
        icon: "/assets/icons/hoyolab.svg",
        url: "https://www.hoyolab.com/genshin/",
      },
      {
        title: "Official Discord",
        description: "Join the official Discord server for real-time chats.",
        icon: "/assets/icons/discord.svg",
        url: "https://discord.gg/genshinimpact",
      },
    ],
  },
  {
    category: "Community Platforms",
    links: [
      {
        title: "Genshin Impact Reddit",
        description: "The largest community forum for discussions and memes.",
        icon: "/assets/icons/reddit.svg",
        url: "https://www.reddit.com/r/Genshin_Impact/",
      },
      {
        title: "KeqingMains (KQM)",
        description:
          "In-depth theorycrafting, character guides, and team building.",
        icon: "/assets/icons/kqm.png",
        url: "https://keqingmains.com/",
      },
    ],
  },
  {
    category: "Essential Tools & Resources",
    links: [
      {
        title: "Interactive Teyvat Map",
        description: "The official map for all Oculi, chests, and materials.",
        icon: "/assets/icons/map.svg",
        url: "https://act.hoyolab.com/ys/app/interactive-map/index.html",
      },
      {
        title: "Genshin Impact Wiki",
        description: "The most comprehensive Fandom wiki for all game info.",
        icon: "/assets/icons/fandom.svg",
        url: "https://genshin-impact.fandom.com/",
      },
    ],
  },
];

export const ELEMENT_ICONS = {
  Pyro: "/image-proxy/Pyro?file=Element_Pyro.png",
  Hydro: "/image-proxy/Hydro?file=Element_Hydro.png",
  Anemo: "/image-proxy/Anemo?file=Element_Anemo.png",
  Electro: "/image-proxy/Electro?file=Element_Electro.png",
  Cryo: "/image-proxy/Cryo?file=Element_Cryo.png",
  Dendro: "/image-proxy/Dendro?file=Element_Dendro.png",
  Geo: "/image-proxy/Geo?file=Element_Geo.png",
};

export const SLIME_ICONS = {
  Anemo: "/image-proxy/Anemo_Slime?file=Anemo_Slime_Icon.png",
  Pyro: "/image-proxy/Pyro_Slime?file=Pyro_Slime_Icon.png",
  Cryo: "/image-proxy/Cryo_Slime?file=Cryo_Slime_Icon.png",
  Electro: "/image-proxy/Electro_Slime?file=Electro_Slime_Icon.png",
  Hydro: "/image-proxy/Hydro_Slime?file=Hydro_Slime_Icon.png",
  Dendro: "/image-proxy/Dendro_Slime?file=Dendro_Slime_Icon.png",
  Geo: "/image-proxy/Geo_Slime?file=Geo_Slime_Icon.png",
};

export const ELEMENT_COLORS = {
  Pyro: "#FF9999",
  Hydro: "#80C0FF",
  Anemo: "#99FFDD",
  Electro: "#FFACFF",
  Cryo: "#99FFFF",
  Dendro: "#A6FF80",
  Geo: "#FFE699",
};

export const THEME_COLORS = {
  default: "#e8d3a3",
  pyro: "#ef7956",
  hydro: "#56a7ef",
  anemo: "#74c2a8",
  electro: "#aa8ed1",
  cryo: "#a0d7e4",
  dendro: "#a5c83b",
};

export const WEAPON_TYPE_ICONS = {
  Sword: "/image-proxy/Sword?file=Icon_Sword.png",
  Claymore: "/image-proxy/Claymore?file=Icon_Claymore.png",
  Polearm: "/image-proxy/Polearm?file=Icon_Polearm.png",
  Catalyst: "/image-proxy/Catalyst?file=Icon_Catalyst.png",
  Bow: "/image-proxy/Bow?file=Icon_Bow.png",
};

export const REGION_ICONS = {
  "Mondstadt": {
    wikiPage: "Mondstadt",
    fileName: "Mondstadt_Emblem_Night.png"
  },
  "Liyue": {
    wikiPage: "Liyue",
    fileName: "Liyue_Emblem_Night.png"
  },
  "Inazuma": {
    wikiPage: "Inazuma",
    fileName: "Inazuma_Emblem_Night.png"
  },
  "Sumeru": {
    wikiPage: "Sumeru",
    fileName: "Sumeru_Emblem_Night.png"
  },
  "Fontaine": {
    wikiPage: "Fontaine",
    fileName: "Fontaine_Emblem_Night.png"
  },
  "Natlan": {
    wikiPage: "Natlan",
    fileName: "Natlan_Emblem_Night.png"
  },
  "Nod-Krai": {
    wikiPage: "Nod-Krai",
    fileName: "Nod-Krai_Emblem_Night.png"
  }
};

export const ROLE_ICONS = {
  "On-Field": {
    wikiPage: "Character_Role",
    fileName: "Character_Role_On-Field.png"
  },
  "Off-Field": {
    wikiPage: "Character_Role",
    fileName: "Character_Role_Off-Field.png"
  },
  "DPS": {
    wikiPage: "Character_Role",
    fileName: "Character_Role_DPS.png"
  },
  "Support": {
    wikiPage: "Character_Role",
    fileName: "Character_Role_Support.png"
  },
  "Survivability": {
    wikiPage: "Character_Role",
    fileName: "Character_Role_Survivability.png"
  }
};

export const CURRENCY_ICONS = {
  genesisCrystals: "/image-proxy/Genesis_Crystal?file=Item_Genesis_Crystal.png",
  primogems: "/image-proxy/Primogem?file=Item_Primogem.png",
  starglitter:
    "/image-proxy/Masterless_Starglitter?file=Item_Masterless_Starglitter.png",
  intertwinedFates:
    "/image-proxy/Intertwined_Fate?file=Item_Intertwined_Fate.png",
  acquaintFates: "/image-proxy/Acquaint_Fate?file=Item_Acquaint_Fate.png",
};
export const PROFILE_BACKGROUNDS = {
  luck_s: {
    wikiPage: "Achievement:_Orbits",
    fileName: "Namecard_Background_Achievement_Orbits.png",
  },
  affinity_pyro: {
    wikiPage: "Natlan:_Draconic_Gaze",
    fileName: "Namecard_Background_Natlan_Draconic_Gaze.png",
  },
  affinity_hydro: {
    wikiPage: "Fontaine:_Judgment",
    fileName: "Namecard_Background_Fontaine_Judgment.png",
  },
  affinity_anemo: {
    wikiPage: "Mondstadt:_Whistling_Wind",
    fileName: "Namecard_Background_Mondstadt_Whistling_Wind.png",
  },
  affinity_electro: {
    wikiPage: "Inazuma:_Kujou_Insignia",
    fileName: "Namecard_Background_Inazuma_Kujou_Insignia.png",
  },
  affinity_dendro: {
    wikiPage: "Sumeru:_Shimmering_Woods",
    fileName: "Namecard_Background_Sumeru_Shimmering_Woods.png",
  },
  affinity_geo: {
    wikiPage: "Liyue:_Stillness_of_Stone",
    fileName: "Namecard_Background_Liyue_Stillness_of_Stone.png",
  },
  affinity_cryo: {
    wikiPage: "Achievement:_Colors_of_the_Rainbow",
    fileName: "Namecard_Background_Achievement_Colors_of_the_Rainbow.png",
  }, // Fallback für Cryo
  default: {
    wikiPage: "Achievement:_Colors_of_the_Rainbow",
    fileName: "Namecard_Background_Achievement_Colors_of_the_Rainbow.png",
  },
};
